<template>
  <div class="flex min-h-screen items-center justify-center" role="status" aria-label="Loading">
    <span class="h-10 w-10 animate-spin rounded-full border-4 border-gray-300 border-t-blue" aria-hidden="true"></span>
  </div>
</template>

<script>
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  setup () {
    onMounted(() => {
      window.location.assign('https://prayerstorm.churchsuite.com/events/9gv5e3ct')
    })
  }
})
</script>
